import React, { useState, useEffect, useMemo } from "react";

function Test() {

    return(
        <div>
            <iframe src="http://192.168.2.105:3000/d-solo/8UPRhjD4z/tordesillas?orgId=1&from=1668396960013&to=1668418560013&panelId=2" width="450" height="200" frameborder="0"></iframe>
        </div>
    )
}

export default Test